import { render, staticRenderFns } from "./InquirySuccess.vue?vue&type=template&id=0810b3d4&scoped=true&"
import script from "./InquirySuccess.vue?vue&type=script&lang=js&"
export * from "./InquirySuccess.vue?vue&type=script&lang=js&"
import style0 from "./InquirySuccess.vue?vue&type=style&index=0&id=0810b3d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0810b3d4",
  null
  
)

export default component.exports